import AppConstants from '../config/app.constants';

let ConfigService = function ($http, $q) {

    let getConfig = () => {
        return $http
            .get(AppConstants.api + `/config/get-config`)
            .then((res) => {
                return res.data
            })
    }

    return {
        getConfig
    };
}

ConfigService.$inject = ['$http', '$q'];

export default ConfigService;


// WEBPACK FOOTER //
// ./client/app/services/config.service.js